import { IComponentOptions } from 'angular';
import { CreditGapsTransferWizardCtrl } from './credit-gaps-transfer-wizard.controller';

export const CreditGapsTransferWizardComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    currentUser: '<',
    courseDiffs: '<',
  },
  controller: CreditGapsTransferWizardCtrl,
  template: require('./credit-gaps-transfer-wizard.html'),
};
